export default __webpack_public_path__ + "static/survey.url-981a94a1098bf4a5b6b1be527a28eb97.svg";